import React from "react";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import SectionSettings from "./SectionSettings";
import IntlMessages from "../../../../util/IntlMessages";

const SectionModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.dataSettings" />} key="2">
            <SectionSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default SectionModal;
